import {
    get,
    isEqual
} from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';
import { TABLE_UNMOUNT } from '../Table/tableActions';
import {
    RESERVE_ACTIVITIES_LOAD,
    RESERVE_ACTIVITIES_SUCCESS,
    RESERVE_ACTIVITIES_FAILURE,
    RESERVE_SUMMARIES_SUCCESS,
    RESERVE_SUMMARIES_LOAD,
    RESERVE_SUMMARIES_FAILURE
} from './reservesActions';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case TABLE_UNMOUNT:
            newState = {
                ...state,
                reserveActivities: []
            };

            return isEqual(state, newState) ? state : newState;

        case RESERVE_ACTIVITIES_LOAD:
            newState = {
                ...state,
                error: null,
                loading: true
            };

            return isEqual(state, newState) ? state : newState;

        case RESERVE_ACTIVITIES_SUCCESS:
            newState = {
                ...state,
                loading: false,
                reserveActivities: action.reserveActivities,
                count: action.count,
                pages: action.pages,
                hasMore: action.hasMore,
                offset: action.offset,
                limit: action.limit
            };

            return isEqual(state, newState) ? state : newState;

        case RESERVE_ACTIVITIES_FAILURE:
            newState = {
                ...state,
                error: action.error,
                loading: false,
                count: 0,
                pages: 0
            };

            return isEqual(state, newState) ? state : newState;

        case RESERVE_SUMMARIES_LOAD:
            newState = {
                ...state,
                error: null,
                summariesLoading: true,
                summariesLoaded: false
            };

            return isEqual(state, newState) ? state : newState;

        case RESERVE_SUMMARIES_SUCCESS:
            newState = {
                ...state,
                summariesLoading: false,
                summariesLoaded: true,
                summaries: action.summaries
            };

            return isEqual(state, newState) ? state : newState;

        case RESERVE_SUMMARIES_FAILURE:
            newState = {
                ...state,
                error: action.error,
                summariesLoading: false,
                summariesLoaded: true
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getReservesEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'reserves')
);

export const getIsReserveActivitiesLoading = createSelector(
    getReservesEntity,
    (entity) => get(entity, 'loading')
);

export const getReserveActivities = createSelector(
    getReservesEntity,
    (entity) => get(entity, 'reserveActivities')
);

export const getReserveActivitiesError = createSelector(
    getReservesEntity,
    (entity) => get(entity, 'reserveActivitiesError')
);

export const getReserveActivitiesErrorMessage = createSelector(
    getReserveActivitiesError,
    (error) => get(error, 'message')
);

export const getIsReserveSummariesLoading = createSelector(
    getReservesEntity,
    (entity) => get(entity, 'summariesLoading')
);

export const getIsReserveSummariesLoaded = createSelector(
    getReservesEntity,
    (entity) => get(entity, 'summariesLoaded')
);

export const getReserveSummaries = createSelector(
    getReservesEntity,
    (entity) => get(entity, 'summaries')
);

export const getReserveSummariesError = createSelector(
    getReservesEntity,
    (entity) => get(entity, 'reserveSummariesError')
);

export const getReserveSummariesErrorMessage = createSelector(
    getReserveSummariesError,
    (error) => get(error, 'message')
);

export const getPages = createSelector(
    getReservesEntity,
    (entity) => get(entity, 'pages')
);

export const getCount = createSelector(
    getReservesEntity,
    (entity) => get(entity, 'count')
);

export const getHasMore = createSelector(
    getReservesEntity,
    (entity) => get(entity, 'hasMore')
);
